export interface ColorInterface {
    primario:string;
    secundario:string;
    terciario:string;
    textoPrimario:string;
    textoSecundario:string;
}

export class Color {
    constructor(
        public primario:string,
        public secundario:string,
        public terciario:string,
        public textoPrimario:string,
        public textoSecundario:string
    ) {
    }
}

export class ColorMaker {
    static createInterface(event:ColorInterface):ColorInterface {
        return { primario: event.primario, secundario: event.secundario, terciario: event.terciario, textoPrimario: event.textoPrimario, textoSecundario: event.textoSecundario }
    }

    static create(event: Color) {
        return new Color( event.primario, event.secundario, event.terciario, event.textoPrimario, event.textoSecundario );
    }
}